<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <b-row class="justify-content-between px-1">
        <h3>
          <feather-icon size="22" icon="BellIcon" />
          الإشعارات
        </h3>
        <b-button
          @click="onAddClicked"
          variant="success"
          v-can="{ slug: $route.meta.slug, action: 'C' }"
        >
          <feather-icon class="align-middle mr-25" icon="PlusIcon" />
          إضافة
        </b-button>
      </b-row>

      <hr />
      <div>
        <div class="w-25">
          <b-input-group dir="rtl" class="input-group-merge">
            <b-form-input v-model="searchKey" placeholder="بحث عن إشعار" />
            <b-input-group-append is-text>
              <feather-icon
                v-if="searchKey.length > 0"
                class="cursor-pointer"
                @click="searchKey = ''"
                icon="XIcon"
              />
              <feather-icon v-else icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>
        </div>
        <template v-if="notifications.length < 1">
          <h4 class="text-center py-2" style="opacity: 0.6">
            <feather-icon
              class="mx-50 align-middle"
              size="18"
              icon="AlertTriangleIcon"
            >
            </feather-icon>
            لا توجد سجلّات بعد.
          </h4></template
        >

        <template v-else>
          <div
            class="notification-card text-weight-bold p-1 my-2 rounded"
            v-for="not in notifications"
            :key="not.id"
          >
            <b-row class="align-items-center">
              <b-col cols="10">
                <h4>{{ not.title }}</h4>
                <div>
                  {{ not.body }}
                </div>
              </b-col>
              <b-col class="d-flex justify-content-end" cols="2">
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'U' }"
                  v-b-tooltip.v-primary.bottom
                  @click="onUpdateClicked(not)"
                  variant="flat-primary"
                  class="btn-icon"
                  title="تعديل الإشعار"
                >
                  <feather-icon size="18" icon="EditIcon" />
                </b-button>
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'O' }"
                  v-b-tooltip.v-success.bottom
                  title="إرسال إلى ..."
                  @click="onSendClicked(not)"
                  variant="flat-success"
                  class="btn-icon mx-25"
                >
                  <feather-icon size="18" icon="SendIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.v-danger.bottom
                  title="حذف الإشعار"
                  variant="flat-danger"
                  class="btn-icon"
                  @click="onDeleteClicked(not.id)"
                >
                  <feather-icon size="18" icon="Trash2Icon" />
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div>
            <!-- Pagination -->
            <b-col
              lg="7"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="pagination.total_row"
                :per-page="pagination.per_page"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </div>
        </template>
      </div>
      <b-modal
        title="إرسال إشعار ..."
        centered
        v-model="sendNotificationModal"
        footer-class="removed"
        no-close-on-backdrop
      >
        <b-form @submit.prevent="onSendModalConfirmed">
          <validation-observer ref="FormValidation">
            <form-input
              label="عنوان الإشعار"
              rules="required"
              v-model="sendForm.title"
            />
            <form-textarea
              class="my-1"
              label="نص الإشعار"
              rules="required"
              v-model="sendForm.body"
            />
            <b-form-radio-group
              v-model="sendForm.is_ministry"
              :options="yesNoOptions"
              name="radios-is_ministry"
            />
            <b-form-checkbox class="my-1" v-model="sendForm.for_all">
              إرسال لجميع المستخدمين
            </b-form-checkbox>

            <form-select
              v-show="
                sendForm.classifications_ids.length === 0 &&
                sendForm.roles_ids.length === 0 &&
                !sendForm.for_all &&
                !sendForm.ngo_id
              "
              label="المحافظات"
              v-model="sendForm.governorates_ids"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="governorates"
              ep="v2/ministry/selects/governorates"
              multiple
              :closeOnSelect="false"
            />
            <form-select
              v-show="
                sendForm.governorates_ids.length === 0 &&
                sendForm.classifications_ids.length === 0 &&
                !sendForm.for_all &&
                !sendForm.ngo_id
              "
              label="الأدوار"
              v-model="sendForm.roles_ids"
              :getOptionLabel="(x) => x.name"
              :reduce="(x) => x.id"
              id="roles-selects"
              :ep="rolesEp"
              multiple
              :closeOnSelect="false"
              ref="rolesSelect"
            />

            <template v-if="!sendForm.is_ministry">
              <form-select
                v-show="
                  sendForm.governorates_ids.length === 0 &&
                  sendForm.roles_ids.length === 0 &&
                  !sendForm.for_all &&
                  !sendForm.ngo_id
                "
                label="التصنيفات"
                v-model="sendForm.classifications_ids"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="classifications"
                ep="v2/ministry/selects/classifications"
                multiple
                :closeOnSelect="false" />
              <div
                v-show="
                  sendForm.classifications_ids.length === 0 &&
                  sendForm.governorates_ids.length === 0 &&
                  sendForm.roles_ids.length === 0
                "
              >
                <form-autocomplete
                  :reduce="(x) => x.id"
                  :getOptionLabel="(x) => x.name_ar"
                  class="my-1"
                  v-show="!sendForm.for_all"
                  ep="v2/ministry/selects/ngos"
                  v-model="sendForm.ngo_id"
                  id="ngo-select"
                  label="المنظمة"
                  placeholder="ابدأ بالكتابة للبحث عن منظمة"
                  :rules="
                    !sendForm.for_all &&
                    sendForm.governorates_ids.length === 0 &&
                    sendForm.roles_ids.length === 0 &&
                    sendForm.classifications_ids.length === 0
                      ? 'required'
                      : ''
                  "
                ></form-autocomplete>
                <b-form-checkbox
                  class="my-1"
                  v-show="!sendForm.for_all"
                  v-model="sendForm.ngoAll"
                >
                  إرسال لجميع مستخدمي المنظمة
                </b-form-checkbox>
                <form-select
                  class="my-1"
                  ref="usersSelect"
                  v-show="!sendForm.ngoAll && !sendForm.for_all"
                  id="users-select"
                  :ep="usersEp"
                  multiple
                  :closeOnSelect="false"
                  v-model="sendForm.users_ids"
                  label="المستخدمين"
                  :getOptionLabel="(x) => x.full_name"
                  :reduce="(x) => x.id"
                  :rules="
                    !sendForm.ngoAll &&
                    !sendForm.for_all &&
                    sendForm.governorates_ids.length === 0 &&
                    sendForm.roles_ids.length === 0 &&
                    sendForm.classifications_ids.length === 0
                      ? 'required'
                      : ''
                  "
                ></form-select></div
            ></template>
            <form-select
              class="my-1"
              ref="ministryUsersSelect"
              v-show="!sendForm.for_all && sendForm.is_ministry"
              id="ministry-users-select"
              ep="v2/ministry/selects/ministry-users"
              multiple
              :closeOnSelect="false"
              v-model="sendForm.users_ids"
              label="المستخدمين"
              :getOptionLabel="(x) => x.full_name"
              :reduce="(x) => x.id"
              :rules="
                !sendForm.for_all &&
                sendForm.governorates_ids.length === 0 &&
                sendForm.roles_ids.length === 0
                  ? 'required'
                  : ''
              "
            ></form-select>

            <hr />
            <div class="w-100 d-flex justify-content-end">
              <b-button
                variant="secondary"
                class="mx-50"
                @click="sendNotificationModal = false"
              >
                إلغاء</b-button
              >
              <loader-btn
                icon="SendIcon"
                label="إرسال"
                loadingLabel="جارٍ الإرسال ..."
                :loading="working"
                variant="success"
                type="submit"
              >
              </loader-btn>
            </div>
          </validation-observer>
        </b-form>
      </b-modal>

      <form-modal
        ref="notificationModal"
        :formSchema="notificationFormSchema"
        title="معلومات الإشعار"
        v-model="notificationModal"
        :loading="working"
        @confirm="onModalConfirmed"
      >
      </form-modal>
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BFormCheckbox,
  BFormRadioGroup,
  BCard,
  BButton,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BForm,
  VBTooltip,
  BPagination
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";
import FormSelect from "@/components/form-select/index.vue";
import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import FormAutocomplete from "@/components/form-autocomplete/index.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import FormInput from "@/components/form-input/index.vue";
import { ValidationObserver } from "vee-validate";
import LoaderBtn from "@/components/loader-btn.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import debounce from "lodash.debounce";

export default {
  components: {
    BRow,
    BFormCheckbox,
    BFormRadioGroup,
    BCard,
    BButton,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BForm,
    FormModal,
    FormSelect,
    LoadingOverlay,
    FeatherIcon,
    FormAutocomplete,
    FormTextarea,
    FormInput,
    ValidationObserver,
    LoaderBtn,
    BPagination
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      currentPage : 1 ,
      sendNotificationModal: false,
      notificationModal: false,
      searchKey: "",
      yesNoOptions: [
        { text: "للمنظمة", value: false },
        { text: "للوزارة", value: true },
      ],
      sendForm: {
        classifications_ids: [],
        governorates_ids: [],
        roles_ids: [],
        is_ministry: false,
        users_ids: [],
      },
      sendNotificationFormSchema: {
        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "عنوان الإشعار",
            rules: "required",
          },
        },

        body: {
          component: "formTextarea",
          key: "body",
          attrs: {
            label: "نص الإشعار",
            rules: "required",
          },
        },
        for_all: {
          key: "for_all",
        },
        ngo_id: {
          key: "ngo_id",
          attrs: {
            label: "المنظمة",
            rules: "required",
            id: "ngo-select",
            ep: "v2/ministry/selects/ngos",
            placeholder: "ابدأ بالكتابة للبحث عن منظمة",
          },
        },
        all_users_ngo: {
          key: "all_users_ngo",
        },
        users_ids: {
          key: "users_ids",
        },
      },
      notificationFormSchema: {
        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "عنوان الإشعار",
            rules: "required",
          },
        },

        body: {
          component: "formTextarea",
          key: "body",
          attrs: {
            label: "نص الإشعار",
            rules: "required",
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("Ministry/Notifications", [
      "loading",
      "working",
      "notifications",
      "pagination"
    ]),
    usersEp() {
      return this.sendForm.ngo_id
        ? "v2/ministry/selects/ngo-users/" + this.sendForm.ngo_id
        : "v";
    },
    rolesEp() {
      return this.sendForm.is_ministry
        ? "v2/ministry/selects/roles?isMinistry=true"
        : "v2/ministry/selects/roles";
    },
  },
  watch: {
    usersEp(val) {
      if (this.$refs.usersSelect) this.$refs.usersSelect.refreshOptions(val);
    },
    rolesEp(val) {
      if (this.$refs.rolesSelect) this.$refs.rolesSelect.refreshOptions(val);
    },
    currentPage(val){
      this.fetchNotifications(this.currentPage);

    },
    searchKey: debounce(function (value) {
      this.filterNotifications(value);
    }, 300),
    "sendForm.is_ministry"(val) {
      this.sendForm = {
        ...this.sendForm,
        for_all: false,
        ngoAll: false,
        is_ministry: val,
        classifications_ids: [],
        governorates_ids: [],
        roles_ids: [],
        users_ids: [],
      };
    },
  },

  methods: {
    ...mapActions("Ministry/Notifications", [
      "filterNotifications",
      "fetchNotifications",
      "addNotification",
      "updateNotification",
      "deleteNotification",
      "sendNotification",
    ]),
    onUpdateClicked(form) {
      var toUpdate = { ...form };
      this.$refs.notificationModal.init(toUpdate);
      this.notificationModal = true;
    },
    onSendClicked(form) {
      this.sendForm = {
        ...form,
        for_all: false,
        ngoAll: false,
        is_ministry: false,
        classifications_ids: [],
        governorates_ids: [],
        roles_ids: [],
        users_ids: [],
      };
      this.sendNotificationModal = true;
    },
    onAddClicked() {
      this.$refs.notificationModal.init({});
      this.notificationModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الإشعار؟", {
          title: "تأكيد حذف الإشعار",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteNotification(id)
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم حذف نموذج الإشعار بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                  },
                });
                
              })
              .catch(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حدث خطأ أثناء تنفيذ العملية",
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              });
          }
        });
    },
    async onSendModalConfirmed() {
      await this.$refs.FormValidation.validate().then(async (success) => {
        if (success) {
          var toSend = {
            title: this.sendForm.title,
            body: this.sendForm.body,
            for_all: this.sendForm.for_all,
            is_ministry: this.sendForm.is_ministry,
          };
          if (!this.sendForm.for_all) {
            if (this.sendForm.governorates_ids.length > 0)
              toSend.governorates_ids = this.sendForm.governorates_ids;
            else if (this.sendForm.roles_ids.length > 0)
              toSend.roles_ids = this.sendForm.roles_ids;
            else if (
              this.sendForm.is_ministry &&
              this.sendForm.users_ids.length > 0
            )
              toSend.users_ids = this.sendForm.users_ids;
            else if (
              !this.sendForm.is_ministry &&
              this.sendForm.classifications_ids.length > 0
            )
              toSend.classifications_ids = this.sendForm.classifications_ids;
            else {
              if (!this.sendForm.is_ministry) {
                toSend.ngo_id = this.sendForm.ngo_id;
                if (!this.sendForm.ngoAll) {
                  toSend.users_ids = this.sendForm.users_ids;
                } else {
                  toSend.users_ids = [0];
                }
              }
            }
          }
          await this.sendNotification(toSend)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم إرسال الإشعار بنجاح",
                  icon: "BellIcon",
                  variant: "success",
                },
              });
              this.sendNotificationModal = false;
            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حدث خطأ أثناء إرسال الإشعار",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
    async onModalConfirmed(form) {
      if (form.id)
        await this.updateNotification(form)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "تم تحديث نموذج الإشعار بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "حدث خطأ أثناء تنفيذ العملية",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      else
        await this.addNotification(form)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "تمت إضافة نموذج الإشعار بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "حدث خطأ أثناء تنفيذ العملية",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      this.notificationModal = false;
    },
  },
  created() {
    this.fetchNotifications(this.currentPage);
  },
};
</script>

<style lang="scss">
.notification-card {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  transition: all 0.2s ease;
}
.notification-card:hover {
  -webkit-transform: translateY(-5px);
  transform: translateY(-5px);
  -webkit-box-shadow: 0 4px 25px 0 rgba(34, 41, 47, 0.25);
  box-shadow: 0 4px 25px 0 rgba(34, 41, 47, 0.25);
}
</style>
